var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-combobox',_vm._g(_vm._b({attrs:{"data-testid":_vm.dataTestid,"items":_vm.fonctions}},'v-combobox',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }